module.exports = __webpack_public_path__ + "acb6843929faf0c6d52aee29ecaabe38.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sutter_health_2023_chart.png
// module id = 1738
// module chunks = 0